import NetworkConnectionService, {ICON_NAMES} from 'external-services/network-connection-service/index';
import TrackingService from 'app/services/tracking/tracking.service';
import {STATUS_CHANGE} from "app/actions/networkConnection.actions";
import {CouchStatus} from "app/app.types";
import AdminService from "external-services/diary-admin-service/admin.service";
import ManagerService from "external-services/manager-service/manager.service";
import SimpleDialogActions from 'app/actions/simpleDialog.actions';

// requiring html templates so that hot reloading works
const template = require('./header.html');
const NS = 'Header'; // jshint ignore:line

export default function Header() {
  "ngInject";

  return {
    scope: {
      pageTitle: '='
    },
    restrict: 'E',
    transclude: true,
    controllerAs: 'header',
    template,
    controller
  };

  function controller($rootScope, $scope, $mdSidenav, $mdDialog, unregister, appValues) {
    "ngInject";

    const vm = this;

    vm.loading = false;
    vm.statusIcon = NetworkConnectionService.getNetworkConnectionIconName();
    vm.statusMessage = NetworkConnectionService.getStatusMessage();

    vm.isManager = ManagerService.isManager;
    vm.venue = AdminService.getVenue();
    vm.appVersion = appValues.VERSION_SHORT;
    vm.isOfflineDisabled = false;

    vm.giftURL = window.config.adminUrl + "dashboard/accounts/" + vm.venue.accountId + "/restaurants/" + vm.venue.id + "/" + "giftcards-management";

    vm.reloadRequired = false;

    // COR-141 deprecation banner: gated per environment by config
    vm.showDeprecationBanner = !!window.config.enableDeprecationBanner;
    vm.supportGuideUrl = window.config.supportGuideUrl || 'https://help.nowbookit.com/knowledge-base/get-started';
    vm.learnHowToSwitch = () => {
      TrackingService.trackEvent('Learn How To Switch');
      window.open(vm.supportGuideUrl, '_blank');
    };
    // layout below the banner (floorplan calc()s, reports print button) reads this variable
    document.documentElement.style.setProperty('--app-banner-h', vm.showDeprecationBanner ? '40px' : '0px');

    // methods
    vm.toggleMainMenu = toggleMainMenu;
    vm.toggleStatusInfo = toggleStatusInfo;
    vm.promptToReload = promptToReload;
    vm.toggleManager = toggleManager;
    vm.callPinDialog = callPinDialog;
    vm.callConfirmationDialog = callConfirmationDialog;

    vm.$onInit = () => {
      const listeners = [];
      listeners.push($rootScope.$on(STATUS_CHANGE, () => {
        statusUpdate();
      }));
      listeners.push($rootScope.$on('manager-change', managerChange));
      listeners.push($rootScope.$on('new-version', showReloadRequiredIcon));
      listeners.push($scope.$on('$destroy', () => unregister(listeners)));
    }

    function managerChange() {
      vm.isManager = ManagerService.isManager;
    }

    function toggleManager(evt) {
      if (!ManagerService.accountLocked) { // This checks whether the account is locked rather than whether the diary is locked
        if (vm.isManager) {
          vm.callConfirmationDialog(evt);
        } else {
          vm.callPinDialog(evt);
        }
      }
    }

    function callPinDialog(evt) {
      $mdDialog.show({
        locals: {accLock: vm.isManager},
        templateUrl: 'app/common/pin/pinDialog.html',
        controller: 'PinCtrl',
        bindToController: true,
        controllerAs: 'vm',
        targetEvent: evt,
        clickOutsideToClose: true
      });
    }

    function callConfirmationDialog(evt) {
      const dialogMessage = 'You are about to lock the diary - are you sure you want to continue?';
      const headerMsg = 'Lock confirmation';
      SimpleDialogActions.showDialog({
        description: dialogMessage,
        title: headerMsg,
        confirmText: 'Confirm',
        rejectText: 'Cancel',
        handleConfirm: () => {
          vm.callPinDialog(evt);
        },
        handleReject: () => {
          SimpleDialogActions.hideDialog();
        }
      });
    }

    function toggleMainMenu() {

      $mdSidenav('mainMenu').toggle();
    }

    function toggleStatusInfo() {
      $mdSidenav('statusInfo').toggle();
    }

    function showReloadRequiredIcon() {
      vm.reloadRequired = true;
    }

    function promptToReload() {
      $rootScope.$broadcast('new-version');
    }


    function statusUpdate() {
      const newCouchStatusConnection = NetworkConnectionService.getCouchStatusConnection();

      vm.isOfflineDisabled = NetworkConnectionService.getOfflineDisabled();

      if (!NetworkConnectionService.isOnline()) {
        vm.statusIcon = ICON_NAMES.OFFLINE;
        vm.statusMessage = NetworkConnectionService.getStatusMessage();
        return;
      }

      vm.statusIcon = NetworkConnectionService.getNetworkConnectionIconName(newCouchStatusConnection);
      vm.statusMessage = NetworkConnectionService.getStatusMessage();

      if (newCouchStatusConnection === CouchStatus.receiving || newCouchStatusConnection === CouchStatus.sending) {
        vm.loading = true;
      } else {
        vm.loading = false;
      }
    }
  }
}
